import React from 'react'
import ProjectStep from "../components/ProjectStep";
import ProjectPosition from "../../../models/ProjectPosition";
import {Collapse} from "antd";
import TalentPoolProvider from "../../../providers/TalentPoolProvider";
import {ProjectVisibilitySettings} from "../../projects/ProjectVisibilitySettingsInfo";

const {Panel} = Collapse;

export default class ProjectVisibilityStep extends ProjectStep {

    static TranslationKey = 'posts_on_job_board_step';

    static path = '/project-visibility-settings';

    static slug = 'project-visibility-settings';

    static sectionName = 'Project Visibility Settings';
    static ValidationMethodName = 'validateVisibilitySettings';
    static FormClass = 'wizard-form-step max-w-[1200px]'


    constructor(props, context) {
        super(props, context);

        let samplePosition = TB.first(this.props.project.sortedPositions());
        this.state = {
            job: ProjectPosition.make({
                ...samplePosition,
                is_match: true,
                has_shown_interest_in_job: false,
                can_show_interest_in_job: true,
                posted_at: new Date().toISOString(),
                estimated_payout: samplePosition.platform_cost,
                is_new: true,
                project: this.props.project,
                client: {
                    ...(context?.auth?.clientOrg() || {})
                }
            })
        }
    }

    static async hasCompleted(formModel, project) {
        let projectProps = await formModel.validateVisibilitySettings()

        if (!projectProps) {
            return false;
        }
        if (!project) {
            return projectProps;
        }
        let selectedPoolIds = TB.map(projectProps.visible_talent_pools || [], 'id');
        let poolsNotOwnedByAuth = TB.filter(project?.visible_talent_pools || [] || [], pool => pool.is_personal && pool?.owner && pool?.owner?.id !== TB.auth()?.user()?.id)

        let didRemoveUserPersonalPool = poolsNotOwnedByAuth?.length > 0 && !!TB.find(poolsNotOwnedByAuth, pool => !selectedPoolIds.includes(pool.id))
        if (!project.is_on_hold && project.isBidding()) {
            let confirm = true;
            if (didRemoveUserPersonalPool && !TB.auth()?.user()?.canManageClients()) {
                confirm = await TB.sysAlert('byo.visible_talent_pool_permission_warning');
            }else if (projectProps.posts_on_talent_job_board) {
                confirm = await TB.sysAlert('byo.visibility_settings_update_note');
            }
            if (!confirm) {
                return false;
            }
        }
        // let currentSettings = formModel?.visibilitySettings();
        // let queries = TB.queryClient.getQueriesData({predicate: ({queryKey}) => {
        //     if (!queryKey || queryKey[0] !== 'getPositionMatchingTalentCount') {
        //         return false;
        //     }
        //     let params = queryKey[1] || {};
        //
        //
        //     let sameSettings = true;
        //     TB.map(params.visibilitySettings, (setting, key) => {
        //
        //         if (!TB.isEqual(setting, currentSettings[key])) {
        //             sameSettings = false;
        //         }
        //     })
        //     return parseInt(params?.projectId) === project?.id && sameSettings;
        // }})
        // let hasLowMatchCountForRole = TB.find(queries || [], ([queryKey, data]) => {
        //     return data?.matches_total <= 10 && data?.possible_matches_total > 10
        // })
        // if (hasLowMatchCountForRole) {
        //     await TB.wait(600)
        //     let confirmMatchCount = await TB.sysAlert('byo.low_talent_matches_warning')
        //     if (!confirmMatchCount) {
        //         return false;
        //     }
        // }

        return projectProps;
    }

    /**
     * @param {Project} project
     * @returns {Object}
     */
    static reviewMapping(project) {

        let reviewSettings = {
            "Posts on Job Board": project.posts_on_talent_job_board ? 'Yes' : 'No',
        }
        /*
         * Location
         */
        let location = laravel.project_visibility_location_settings?.[project.visibility_setting_location];
        if (!location) {
            location = TB.first(TB.values(laravel.project_visibility_location_settings));
        }
        reviewSettings["Location"] = location;

        let target = [];
        if (!project.hasVisibilityPoolRestrictions()) {
            target.push("All Talent")
        } else {
            if (project.visibility_setting_favorites) {
                target.push("Favorites")
            }
            if (project.visibility_setting_hired) {
                target.push("Previously Hired")
            }
            if (project.visibility_setting_invited) {
                target.push("My Network")
            }
        }
        /*
         * Default pools
         */
        if (target?.length > 1) {
            const last = target.pop();
            target = target.join(", ") + ' and ' + last;
        } else {
            target = target.join(", ")
        }
        reviewSettings["Target Candidates"] = target;

        /*
         * Talent pools
         */
        if (project.visible_talent_pools?.length > 0) {
            let pools = TB.map(project.visible_talent_pools, 'name')
            if (pools?.length > 1) {
                const last = pools.pop();
                pools = pools.join(", ") + ' and ' + last;
            } else {
                pools = pools.join(", ")
            }
            reviewSettings["Talent Pools"] = pools
        }

        return {
            "Project Visibility Settings": reviewSettings
        }
    }


    /**
     * The fields mapping for the form
     */
    formFields = () => {

        return []
    };

    renderFormHeader() {
        return (
            <div className="visibility-step">
                <TalentPoolProvider>
                    <ProjectVisibilitySettings {...this.props}>
                        {this.props.children}
                    </ProjectVisibilitySettings>
                </TalentPoolProvider>
            </div>
        );
    }
}